import {
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  Grow,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { CreateAgentForm } from "..";

export const CreateAgent = ({ open, onClose, onCreated }) => {
  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      onClose={(event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") return;
        onClose();
      }}
      maxWidth="xs" // Opciones: xs, sm, md, lg, xl
      fullWidth
      TransitionComponent={Grow}
      transitionDuration={500}
      PaperProps={{
        sx: {
          borderRadius: 2,
          marginTop: 10,
        },
        style: {
          zIndex: 1600,
        },
      }}
    >
      <DialogTitle
        component="div"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 1,
          pt: 0.5,
        }}
      >
        <Typography variant="h3" sx={{ py: 2 }}>
          Crear Agente
        </Typography>

        <IconButton
          aria-label="cerrar"
          onClick={onClose}
          sx={{
            color: (theme) => theme.palette.grey[500],
            "&:hover": {
              color: (theme) => theme.palette.grey[700],
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          pt: 1,
          pb: 3,
        }}
      >
        <CreateAgentForm onCancel={onClose} onCreated={onCreated} />
      </DialogContent>
    </Dialog>
  );
};
